import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import { SectorPayloadT, SectorsGetListResponseT } from '../types/sectors.types'

export class SectorsRepository {
    getList(): Promise<AxiosResponse<SectorsGetListResponseT>> {
        return http.get('/cabinet/api/sector')
    }

    updateSector(sector_id: number, payload: SectorPayloadT): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/sector/${sector_id}`, payload)
    }

    createSector(payload: SectorPayloadT): Promise<AxiosResponse<void>> {
        return http.post('/cabinet/api/sector', payload)
    }

    deleteSector(sector_id: number): Promise<AxiosResponse<any>> {
        return http.delete(`/cabinet/api/sector/${sector_id}`)
    }
}
